import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src'

import {Tag} from '@vio/atlas/Tag'
import {cssTheme} from '@vio/atlas/themes'
import minus from '@vio/atlas/utils/minus'

import {DotSeparatedList} from '../DotSeparatedList'

// Tags have bottom margin to simulate row-gap, reset it so the rest of the layout can flow correctly
// This can be cleaned up when row-gap has enough browser support
const ShouldResetTagSpacing = styled.div`
  &.--has-spacing {
    margin-bottom: ${minus(cssTheme.layout.spacing.s300)};
  }
  margin-bottom: 0;
`

const TagSpacing = styled.div`
  display: inline-block;
  margin-right: ${cssTheme.layout.spacing.s300};
  margin-bottom: 0;
  &.--has-spacing {
    margin-bottom: ${cssTheme.layout.spacing.s300};
  }
`

const TagWrapper = styled.div`
  white-space: nowrap;
`

const TagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s300};
`

interface Props {
  sentiments: ContentHotel['sentiments']
  hasResetTagSpacing?: boolean
  variant?: 'normal' | 'slider'
  isCompact?: boolean
}

export const ReviewSentiments: React.FC<Props> = ({
  sentiments,
  hasResetTagSpacing = true,
  variant = 'normal',
  isCompact = false
}) => {
  const sentimentsToShow = sentiments?.slice(0, 6).filter(Boolean) || []
  const values = sentimentsToShow.map(sentiment => sentiment.value)
  if (isCompact) {
    return (
      <DotSeparatedList values={values} isSingleLine={variant === 'slider'} />
    )
  }

  if (variant === 'slider') {
    return (
      <TagContainer>
        {sentimentsToShow.map(sentiment => (
          <TagWrapper key={sentiment.id}>
            <Tag variant="neutral" size="md">
              {`"${sentiment.value}"`}
            </Tag>
          </TagWrapper>
        ))}
      </TagContainer>
    )
  }

  return (
    <ShouldResetTagSpacing
      className={cx(hasResetTagSpacing && '--has-spacing')}
    >
      {sentimentsToShow.map(sentiment => (
        <TagSpacing
          key={sentiment.id}
          className={cx(hasResetTagSpacing && '--has-spacing')}
        >
          <Tag variant="neutral" size="md">
            {`"${sentiment.value}"`}
          </Tag>
        </TagSpacing>
      ))}
    </ShouldResetTagSpacing>
  )
}
